import TransactionCardSkeleton from './transaction-card-skeleton'
import TransactionVolumeCardSkeleton from './transaction-volume-card-skeleton'

const TransactionsContentSkeleton = () => {
  return (
    <div className="flex w-full flex-col gap-3 text-clip">
      <TransactionVolumeCardSkeleton />
      <div className="mt-4 flex flex-col">
        {[...Array(3)].map((_, index) => (
          <TransactionCardSkeleton key={index} />
        ))}
      </div>
    </div>
  )
}

export default TransactionsContentSkeleton
